// Inherited translations name the original product; screens must show the installation name instead.
// Only the capitalized word is replaced, so identifiers such as window.chatwootSettings and
// {latestChatwootVersion} inside messages keep working.
const PRODUCT_NAME = /\bChatwoot\b/g;
const MESSAGE_SYNTAX = /[{}@|]/g;

const asLiteral = text => text.replace(MESSAGE_SYNTAX, char => `{'${char}'}`);

const replaceInMessages = (messages, installationName) => {
  if (typeof messages === 'string') {
    return messages.replace(PRODUCT_NAME, () => installationName);
  }
  if (Array.isArray(messages)) {
    return messages.map(item => replaceInMessages(item, installationName));
  }
  if (messages && typeof messages === 'object') {
    return Object.fromEntries(
      Object.entries(messages).map(([key, value]) => [
        key,
        replaceInMessages(value, installationName),
      ])
    );
  }
  return messages;
};

export const withInstallationName = (
  messages,
  installationName = window.globalConfig?.INSTALLATION_NAME
) =>
  installationName
    ? replaceInMessages(messages, asLiteral(installationName))
    : messages;
